import { Badge, BadgeColor } from '@odin-labs/components';
import classNames from 'classnames';
import React from 'react';

export type LayoutEntityCardProps = {
  title: string;
  subtitle?: string;
  tag?: { text: string; color: BadgeColor } | null;
  selected: boolean;
  onClick: () => void;
};

const classes = {
  // No clickable card exists in the component library; this is a button
  // styled as a row so it stays keyboard-operable and announces selection.
  card: (selected: boolean): string =>
    classNames(
      'odin-flex odin-w-full odin-items-center odin-justify-between odin-gap-2 odin-rounded-md odin-px-3 odin-py-2 odin-text-left',
      'odin-transition-colors focus:odin-outline-none focus-visible:odin-ring-2 focus-visible:odin-ring-odin-primary',
      selected ? 'odin-bg-gray-100' : 'hover:odin-bg-gray-50',
    ),
  text: 'odin-flex odin-min-w-0 odin-flex-col',
  title:
    'odin-block odin-truncate odin-text-sm odin-font-medium odin-text-gray-900',
  subtitle: 'odin-block odin-truncate odin-text-xs odin-text-gray-500',
};

export function LayoutEntityCard({
  title,
  subtitle,
  tag,
  selected,
  onClick,
}: LayoutEntityCardProps): React.ReactElement {
  return (
    <button
      type="button"
      aria-pressed={selected}
      className={classes.card(selected)}
      onClick={onClick}
    >
      <span className={classes.text}>
        <span className={classes.title}>{title || 'Unnamed'}</span>
        {subtitle && <span className={classes.subtitle}>{subtitle}</span>}
      </span>
      {tag && <Badge text={tag.text} color={tag.color} />}
    </button>
  );
}
